import React, { Component } from 'react';
import _ from 'lodash';

import { Grid, Link, Paper, Typography } from '@material-ui/core';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import contentService from '../../services/contentService';
import { connect } from 'react-redux';
import { NotesQuestionPreview, NotesTheoryPreview, NotesVideoPreview, AudioPreviewNotes } from './NotesContentPreview';

import { DocumentLoadEvent, PageChangeEvent, ProgressBar, Worker } from '@react-pdf-viewer/core';
import { MyPATLink } from '../../../common';

import ContentData from '../../types/ContentData';
import ConceptIncludesPopup from './ConceptIncludesPopup';
import { Viewer } from '@react-pdf-viewer/core';
import * as JSLZString from 'lz-string';
import * as LZString from 'lz-string';
import PDFViewer from '../ContentCreate/PDFViewer';
import { NOTES_SECTION, NOTES_TYPE, OBJECTIVE_NOTES, SUBJECTIVE_NOTES, TABLE_OF_CONTENT, TYPE_OF_CONTENT } from '../../../../constants/comman';
import { getTypeOfNotes } from '../../helper/notesPayload';

const styles = (theme: Theme) =>
  createStyles({
    paperOverview: {
      padding: theme.spacing.unit * 2,
	  marginBottom: 15,
	  '& h2':{
		  display: 'flex',
		  justifyContent: 'space-between',
		  alignItems: 'flex-start',
		  '& span.type':{
			  fontSize: 16,
			  fontWeight: 600,
			  color: '#333',
			  minWidth: '100px',
			  textAlign: 'right',
			  lineHeight: '170%',
		  }
	  }
    },
    keyValueContainer: {
      "& *": {
        display: "inline",
        marginRight: "4px",
      },
      marginTop: theme.spacing.unit * 2,
    },
    overviewMeta: {
      opacity: 0.6,
    },
    metaInfoBox: {
      padding: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      border: `1px solid ${theme.palette.background.default}`,
      borderRadius: "2px",
    },
    metaInfoBoxTable: {
      border: 0,
    },
    cursor: {
      cursor: "pointer",
      fontWeight: 600,
    },
    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p > img, img": {
        maxWidth: "100%",
      },
    },
    paddingSM: {
      padding: 16,
    },
    optionText: {
      display: "flex",
      whiteSpace: "nowrap",
      margin: "4px 0px",
      lineHeight: "38px",
      "& > span > p": {
        display: "inline",
        marginLeft: theme.spacing.unit,
      },
    },

    tagsList: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.unit,
      "&:after": {
        content: '"|"',
        marginLeft: theme.spacing.unit,
      },
      "&:last-child": {
        marginRight: 0,
        "&:after": {
          display: "none",
        },
      },
    },

    wrapText: {
      clear: "both",
      width: "100%",
      display: "inline-block",
      maxWidth: "96%",
      overflowX: "auto",
      whiteSpace: "initial",
      overflowY: "hidden",
      "& p": {
        margin: "0px",
        textAlign: "justify",
      },
    },

    widthSet: {
      width: "100%",
      "& .MyPATExpansionPanel-greyBackground-452": {
        backgroundColor: "#fff",
        background: "#fff !important",
      },
    },

    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },

    fontXS: {
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "#333",
    },

    blueColor: {
      color: "#1D7DEA",
    },

    greyColor: {
      color: "#333333",
    },
    fontSizemd: {
      fontSize: "20px",
      fontWeight: 400,
    },
    previewTitle: {
      fontWeight: 700,
    },

    marginTop: {
      marginTop: "2rem",
    },
    uploadPreviewBox: {
      minHeight: 16,
      position: "relative",
      maxHeight: 500,
      overflowY: "auto",
	  marginLeft: '-15px',
	  marginRight: '-15px',
	  overflowX: 'hidden',
	  	'& .rpv-core__inner-page':{
			paddingTop: '0 !important',
		},
		'& .rpv-core__page-layer':{
			width: 'calc(100% - 15px) !important',
		},
    },
    pdfHeader: {
		top: '-10px',
		zIndex: 2,
		position: 'absolute',
		width: '100%',
    },
	pdfView: {
		width: "calc(100% - 30px)",
		zIndex: 100,
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,		
		backgroundColor: "#00000091",
		height: "40px",
		lineHeight: "40px",
		color: "#fff",
		padding: "0 15px",
		margin: '10px auto 0',
	  },
	  titleBox:{
		marginLeft: "-15px",
		marginRight: "-15px",
		padding: "0 15px 15px 15px",
		borderBottom: "1px solid #eee",
		marginBottom: 5,
		'& h2':{
			margin: 0,
			fontSize: 20,
			'& span':{
				fontWeight: 'lighter',
			}
		}
	  }
  });




//@ts-ignore
interface NotesPreviewProps extends WithStyles<typeof styles> {
	classes: any,
	content: any,
	addNotes: any,
}

interface NotesPreviewStates {
	title: any,
	conceptTypeToShow: 'primary' | 'secondary' | '',
	pdfPageData:any,
}

class NotesPreview extends Component<NotesPreviewProps, NotesPreviewStates>{
	constructor(props: NotesPreviewProps) {
		super(props);
		this.state = {
			title: '',
			conceptTypeToShow: '',
			pdfPageData: {
                currentPage: 1,
                totalPages: 0
            }
		}
	}


	checkPracticeSetNotes() {

		const notesType = _.get(this.props.content, 'content.subType', '');

		return OBJECTIVE_NOTES.includes(notesType) || SUBJECTIVE_NOTES.includes(notesType);

	}
	
	getConceptsTagged() {
		const { content, classes } = this.props;

		let subjects = _.get(content, "subjects", []);

		if (this.checkPracticeSetNotes() && subjects.length)
			subjects = [subjects[subjects.length - 1]];
		
		return _.reduce(
		 subjects,
		  (acc: JSX.Element[], s) => {
			s.chapters.forEach((c: any) => {
			  c.concepts.forEach((cc: any) => {
				let conceptName = _.get(cc, "conceptId.name");
				let conceptCode = _.get(cc, "conceptCode");
				if (conceptName) {
				  acc.push(
					<Typography variant="body1">
					  {conceptName}{" "}
					  {conceptCode && (
						<Typography variant="h6" inline className={classes.fontXS}>
						  (ID: {conceptCode})
						</Typography>
					  )}
					</Typography>
				  );
				}
			  });
			});
			return acc;
		  },
		  []
		);
	  }
	setConceptTypeToShow = (conceptTypeToShow: 'primary' | 'secondary' | '') => {
		this.setState({
			conceptTypeToShow
		})
	}
	handlePageChange = (e: PageChangeEvent) => {
        let event:PageChangeEvent = Object.assign({}, e)
       
        let data = JSON.parse(JSON.stringify(this.state.pdfPageData));
        if(data.currentPage != event.currentPage + 1) {
            data.currentPage =event.currentPage+1

            this.setState({
                pdfPageData : data
              })
        }

        localStorage.setItem('current-page', e.currentPage.toString());
    };
     onDocumentLoad = (e: DocumentLoadEvent) => {
         let event:DocumentLoadEvent = e
        
        let data = JSON.parse(JSON.stringify(this.state.pdfPageData))
        if(data.totalPages != event.doc.numPages) {
            data.totalPages = event.doc.numPages ;

            this.setState({
                pdfPageData : data
              })
        }
      localStorage.setItem('total-page', e.doc.numPages.toString());
      //return  (e.doc.numPages)
  };
  capitalize(str: string){
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
	getTableOfContent() {

		if (this.checkPracticeSetNotes())
			return TABLE_OF_CONTENT.PRACTICE_SET;

		return TABLE_OF_CONTENT.STUDY_MATERIAL;
	}

	getContentName() {
		return this.checkPracticeSetNotes() ? TABLE_OF_CONTENT.PRACTICE_SET : TABLE_OF_CONTENT.NOTES;
	}

	getNoteSubType() {

		const notesType = _.get(this.props.content, 'content.subType')

		return getTypeOfNotes(notesType);
	}

	theoryRendor() {
		const notesType = _.get(this.props.content, 'content.subType')

		return !SUBJECTIVE_NOTES.includes(notesType);
	}
	render() {
		const { classes, content : { tags = [], content = {} } , addNotes } = this.props;
		const { pages = [], status, subjects = [] } = content;
		const { conceptTypeToShow,pdfPageData } = this.state;
		const primaryConceptsTagged = this.getConceptsTagged();
		let pdfType = '';
		if (pages && pages.length) {
			if (pages[0].type === 'PDF') {
				if (pages[0].subType === 'WORKBOOK') {
					pdfType = 'Workbook';
				} else {
					pdfType = 'PDF Notes';
				}
			}
		}
		const url ='https://mypat-v2-prod.s3-us-west-2.amazonaws.com/invoice/615815808cfca0251aef7a7f.pdf'
		//later change url to dynamic
		return (
			<>
				<Paper className={classes.paperOverview}>
					<div>
						<Typography className={classes.fontSizemd}> <b className={classes.previewTitle}>Content Name:</b> {this.getContentName()}</Typography>
					</div>
					<div className={classes.metaInfoBox}>
						<Grid container>
							<Grid item xs={4}>
								<Typography
									variant="body2"
									className={[classes.fontSM, classes.greyColor].join(" ")}
								>
									Content Type:{" "}
								</Typography>
								<Typography variant="body1">
									{this.getTableOfContent()}
								</Typography>
							</Grid>
							<Grid item xs={4}>
								<Typography
									variant="body2"
									className={[classes.fontSM, classes.greyColor].join(" ")}
								>
									Content Category:{" "}
								</Typography>
								<Typography
									variant="body1"
									style={{ textTransform: "capitalize" }}
								>
									Type:{" "}
									{this.getNoteSubType()}
									<br/>
								</Typography>
							</Grid>
						</Grid>
						<Grid container className={classes.marginTop}>
							<Grid item xs={8}>
								<Typography
									variant="body2"
									className={[classes.fontSM, classes.greyColor].join(" ")}
								>
									Concept Includes:
										</Typography>
								<Grid container>
									<Grid item xs>
										{primaryConceptsTagged.slice(0, 3)}
										{primaryConceptsTagged.length > 0 && (
											<div>
												<Link
													className={classes.cursor}
													color="primary"
													onClick={() =>
														this.setConceptTypeToShow("primary")
													}
												>
													View all
												</Link>
											</div>
										)}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</div>
				</Paper>
				<Paper className={classes.paperOverview}>
					<div className={classes.titleBox}>
					<h2>
					<b> Title:&nbsp;
						<span
						dangerouslySetInnerHTML={{
							__html: _.get(content, "title", "-"),
						}}
						/>
						</b>
						<span className="type">{pdfType}</span>
					</h2>
					</div>
					<div className={classes.uploadPreviewBox}>
						{
							pages && pages.map((element: any) => {

								if (element.type === 'QUESTION') {
									return <NotesQuestionPreview content={element} tags= {tags} notesData={this.props.content} />
								}
								if(element.type === 'PDF'){
									let url: any = element.metaData.pdf.url ? JSLZString.decompressFromEncodedURIComponent(element.metaData.pdf.url) : '';
									const password = element.metaData.pdf.code;
								let pdfName = url.split("studyMaterial_")[1];
								pdfName = pdfName.split("_")[1]
								if(!pdfName.includes(".pdf")) {
									pdfName = pdfName + ".pdf"
								}
								return (
                //   <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                //     <Grid className={classes.pdfHeader}>
                //       <Grid className={classes.pdfView}>
                //         <Grid container justify="space-between">
                //           <Grid item>{this.capitalize(pdfName)}</Grid>

                //           <Grid item>
                //             Page {pdfPageData.currentPage}/
                //             {pdfPageData.totalPages}
                //           </Grid>
                //         </Grid>
                //       </Grid>
                //     </Grid>
                //     <div
                //       style={{
                //         height: "500px",
                //         width: "100%",
                //       }}
                //     >
                //       <Viewer
                //         fileUrl={url} //element[0].metaData.pdf.url when data coming form api
				// 		onPageChange={this.handlePageChange}
                //         onDocumentLoad={this.onDocumentLoad}
                //       />
                //     </div>
                //   </Worker>
							   <PDFViewer
                                url={url}
                                password={password || ""}
                                onPageChange={this.handlePageChange}
                                onDocumentLoad={this.onDocumentLoad}
                            />
                );
							}
								if (element.type === 'THEORY' &&this.theoryRendor()) {
									return <NotesTheoryPreview content={element} />
								}
								if (element.type === 'VIDEO') {
									return <NotesVideoPreview content={element} />
								}
								if (element.type === 'AUDIO') {
									return <AudioPreviewNotes content={element} />
								}
							})
						}
					</div>
				</Paper>
				{!!conceptTypeToShow && (
          <ConceptIncludesPopup
            onClose={() => this.setConceptTypeToShow("")}
            primaryConcepts={primaryConceptsTagged}
            conceptType={conceptTypeToShow}
          />
        )}
      </>
    );
	}
}
const mapStateToProps = (state: any) => ({

	addNotes: _.get(state, 'studyMaterialReducer')
});

// @ts-ignore 
export default connect(mapStateToProps)(withStyles(styles)(NotesPreview));